// extracted by mini-css-extract-plugin
export default {"section":"MyRatingSection_section__MElSb","title":"MyRatingSection_title__2WZL9","row":"MyRatingSection_row__KXRsX","score":"MyRatingSection_score__Eftwa"};